<template>
      <div class="row">
        <div class="col-md-12">
          <div class="widget-alpha__description widget-alpha__amount" style="float: right; margin: 10px; clear:both;color: #ff8625;">
            Wallet balance:
            <span class="widget-alpha__amount">
              ₦{{getUserSession.wallet}}
            </span>
          </div>
          <div class="widget-alpha__description" style="float: right; margin: 10px; clear:both">
            <b-button :variant="`info`" size="sm" @click="paymentFormSelected = `wallet funding`" to="/shs/pay?type=wallet">
              Fund Wallet
            </b-button>
          </div>
        </div>
          <div class="container" style="background: #fff; padding: 0px;">
              <figure class="snip1208">
                <img src="/static/img/Picture.png" alt="Solar Services"/>
                <div class="date"><span class="day">{{getDate('day')}}</span><span class="month">{{getDate('month')}}</span></div>
                <i class="fa fa-newspaper-o"></i>
                <figcaption>
                  <h3>Arnergy Solar Services</h3>
                  <p>
                      The Arnergy IOT dashboard allows customers to monitor their usage. Our dashboard informs users of their battery levels, daily energy consumption, and faults occuring on their devices. Our users can access their dashboards with any device, whether a laptop, tablet or mobile phone.
                  </p>
                  <button>Read More</button>
                </figcaption><a href="#"></a>
              </figure>
          </div>
          </div>
</template>


<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
moment.updateLocale('en', {
          monthsShort :  'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_')
      });
export default {
  name: "",
  methods: {
    triggerPaygate() {
      this.$refs.upay_form.click();
    },
    getDate(type){
      return type == 'day'?moment().format('Do'):moment().format("MMM");
    }
  },
  computed: {
    ...mapGetters(["getUserSession"])
  }
};
</script>

<style lang="scss" scoped>


figure.snip1208 {
  font-family: 'Poppins', Arial, sans-serif;
  color: #fff;
  position: relative;
  // float: left;
  overflow: hidden;
  // margin: 10px 1%;
  min-width: 220px;
  max-width: 100%;
  width: 100%;
  background-color: #ffffff;
  color: #000000;
  text-align: left;
  font-size: 16px;
}
figure.snip1208 * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
figure.snip1208 img {
  max-width: 100%;
  vertical-align: top;
  -webkit-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
figure.snip1208 figcaption {
  padding: 25px;
  position: relative;
}
figure.snip1208 .date,
figure.snip1208 i {
  background-color: #1abc9c;
  top: 25px;
  color: #fff;
  left: 25px;
  min-height: 60px;
  min-width: 60px;
  position: absolute;
  text-align: center;
}
figure.snip1208 .date {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
}
figure.snip1208 .date span {
  display: block;
  line-height: 30px;
}
figure.snip1208 .date .month {
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.1);
}
figure.snip1208 i {
  line-height: 60px;
  font-size: 30px;
  -webkit-transform: rotateY(-90deg);
  transform: rotateY(-90deg);
  -webkit-transition-delay: 0s;
  transition-delay: 0s;
}
figure.snip1208 h3,
figure.snip1208 p {
  margin: 0;
  padding: 0;
}
figure.snip1208 h3 {
  margin-bottom: 10px;
  display: inline-block;
  font-weight: 600;
  color: #333333;
  text-transform: uppercase;
}
figure.snip1208 p {
  font-size: 0.8em;
  margin-bottom: 20px;
  line-height: 1.6em;
}
figure.snip1208 button {
  border: medium none;
  padding: 10px 20px;
  background-color: #1abc9c;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 0.8em;
}
figure.snip1208 a {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;
  z-index: 1;
}
figure.snip1208:hover img,
figure.snip1208.hover img {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
figure.snip1208:hover .date,
figure.snip1208.hover .date {
  -webkit-transform: rotateY(90deg);
  transform: rotateY(90deg);
  -webkit-transition-delay: 0s;
  transition-delay: 0s;
}
figure.snip1208:hover i,
figure.snip1208.hover i {
  -webkit-transform: rotateY(0);
  transform: rotateY(0);
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
figure.snip1208:hover button,
figure.snip1208.hover button {
  background-color: #1893ca;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/rightBar.vue